import React, { Component } from 'react'
import { connect } from 'react-redux'

import Section from 'components/Section'
import Employment from './Employment'
import Rent from './Rent'

import { doc, dirtyRead } from 'selectors/common'

let select = dirtyRead(
	(state, props) => ({
		application: doc(state, props.applicationID)
	})
)

export class PrimaryResident extends Component{
	render(){
		let { props } = this
		let resident = props.application.primaryResident
		return(
			<Section
				id="primaryResident"
				title={`Primary resident: ${resident.firstName} ${resident.lastName}`}
				top={true}
			>
				<div className="primary-resident" style={{paddingLeft: "30px"}}>
					<div className="age">
						<p>Age: {resident.age}</p>
					</div>
					<div className="ssn">
						<p>SSN: {resident.ssn}</p>
					</div>
					<div className="dob">
						<p>DOB: {resident.dob}</p>
					</div>
					<div className="cell">
						<p>Cell: {resident.cell}</p>
					</div>
					<div className="email">
						<p>Email: {resident.email}</p>
					</div>
					<Employment data={resident.employment} />
					<Rent data={resident.rentalHistory}/>
				</div>
			</Section>
		)
	}
}
export default connect(select)(PrimaryResident)



// WEBPACK FOOTER //
// ./src/routes/manager/applicationForm/PrimaryResident.js